import { render, staticRenderFns } from "./EOArchitectureWorkshopLeft.vue?vue&type=template&id=0d89a074&"
import script from "./EOArchitectureWorkshopLeft.vue?vue&type=script&lang=js&"
export * from "./EOArchitectureWorkshopLeft.vue?vue&type=script&lang=js&"
import style0 from "./EOArchitectureWorkshopLeft.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow})
    

export default component.exports